import type {
  BundleProductFragment,
  CommonProductDetailFragment,
  CommonProductFragment,
  ProductDetailFragment
} from '~/lib/Shop/generated/schema';

/**
 * Checks if the given product is a BundleProduct.
 *
 * @param product The product to check.
 */
export function isBundleProduct(
  product?: CommonProductFragment | CommonProductDetailFragment | null
): product is ProductDetailFragment & BundleProductFragment {
  return product?.__typename === 'BundleProduct';
}
